"use strict";
export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : '';
        this.reference = item != null ? item.reference : '';
        this.supplierCarpet = item != null ? item.supplierCarpet : '';
        this.transportFinishedProduct = item != null ? item.transportFinishedProduct : 0;
        this.note = item != null ? item.note : '';
        this.orderLines = item != null ? item.orderLines : [];
    }
}
